import {Injectable} from '@angular/core';
import {ChartDesignVersionManagerService} from './chart-design-version-manager.service';
import {ChartType} from '../models/chartType';
import {ChartModel} from '../models/chart';
import {ChartDesignSettings} from '../models/chartDesignSettings';

@Injectable()
export class ChartFactoryService {

  initialAxisProperties = {
    x: {
      titrToggle: false,
      titrText: '',
      titrFontFamily: 'iranyekan',
      titrFontSize: 9,
      titrColor: '#4D4D4D',
      scaleName: 'گسسته',
      scaleColor: '#0000001A',
      scaleFontFamily: 'iranyekan',
      scaleFontSize: 10,
      scaleTextColor: '#666',
      toggleGuidelines: false,
      guidelinesColor: 'rgba(0, 0, 0, 0.1)',
      toggleLimitChars: true,
      maxChars: 10,
      overflowEnabled: false,
      overflowAmount: 0,
    },
    y: {
      titrToggle: false,
      titrText: '',
      titrFontFamily: 'iranyekan',
      titrFontSize: 9,
      titrColor: '#4D4D4D',
      scaleColor: '#0000001A',
      scaleFontFamily: 'iranyekan',
      scaleFontSize: 10,
      scaleTextColor: '#666',
      place: 'چپ',
      lineToggle: true,
      scaleName: 'خطی',
      angleMin: null,
      angleMax: null,
      toggleGuidelines: true,
      guidelinesColor: 'rgba(0, 0, 0, 0.1)',
      totalBarEnabled: true,
      totalBarPosition: 'end',
      offset: false,
      unit: 'None',
    },
  };

  specificBarChartProperties = {
    transparentDisplay: false,
    multiColorBar: false,
    headerAlignmentOption: 'Right',
    dataLanguage: 'Fa',
    toggleLabelMoreSetting: false,
    labels: {
      columns: {},
    },
    toggleLegendLimitChars: true,
    legendMaxChars: 10,
    borderRadius: 0,
    barPercentage: 0.9,
    zoomToggle: true,
    groupLabelUnit: 0,
  };

  specificLineChartProperties = {
    customSeries: false,
    stepped: false,
    tension: 0.3,
    headerAlignmentOption: 'Right',
    toggleLabelMoreSetting: false,
    labels: {
      columns: {},
    },
    toggleLegendLimitChars: true,
    legendMaxChars: 10,
    dataLanguage: 'Fa',
    columnsLineStyleOptions: {
      styleOnEachColumn: false,
      allLineType: 'line',
      allLineWidth: 3,
      columns: {},
    },
    columnsPointStyleOptions: {
      pointOnEachColumn: false,
      allPointStyle: 'circle',
      allPointRadius: 1,
      columns: {},
    },
    zoomToggle: true,
  };

  specificColumnLineChartProperties = {
    borderColor: '#eaeaea',
    pointColor: 'red',
    labelRotation: 'افقی',
    tension: 0.3,
    columnsPointStyleOptions: {
      pointOnEachColumn: false,
      allPointStyle: 'circle',
      allPointRadius: 1,
      columns: {},
    },
    groupLabelUnit: 0,
    borderRadius: 0,
  };

  specificCardChartProperties = {
    borderColor: '#eaeaea',
    guideAlign: 'center',
    labelColor: '#4D4D4D',
    labelFontSize: 24,
    scale: 'بدون مقیاس',
    field: true,
    fieldNameFontFamily: 'iranyekan',
    fieldNameFontSize: 18,
    fieldNameColor: '#4D4D4D',
    headerAlignmentOption: 'Right',
    textAlign: 'Center',
    toggleCustomText: false,
    customText: '',
    customTextFontFamily: 'iranyekan',
    customTextFontSize: '18',
    customTextColor: '#4D4D4D',
    toggleIcon: false,
    iconType: null,
    iconSize: 42,
    iconColor: '#4D4D4D',
    svgIconSize: 42,
    svgIconColor: '#4D4D4D',
    imageScale: 'fullWidth',
    iconAlignment: 'center',
    iconCardAlignment: 'Right',
    iconCardBackgroundColor: '#FFFFFF',
    iconCardBorderSize: 0,
    iconCardBorderColor: '#FFFFFF',
    iconCardBorderRadius: 0,
    dataLanguage: 'Fa',
  };
  specificAdvancedCardChartProperties = {
    borderColor: '#eaeaea',
    guideAlign: 'center',
    labelColor: '#4D4D4D',
    labelFontSize: 24,
    scale: 'بدون مقیاس',
    field: true,
    fieldNameFontFamily: 'iranyekan',
    fieldNameFontSize: 18,
    fieldNameColor: '#4D4D4D',
    headerAlignmentOption: 'Right',
    textAlign: 'Center',
    toggleCustomText: false,
    customText: '',
    customTextFontFamily: 'iranyekan',
    customTextFontSize: '18',
    customTextColor: '#4D4D4D',
    toggleIcon: false,
    iconType: null,
    iconSize: 42,
    iconColor: '#4D4D4D',
    svgIconSize: 42,
    svgIconColor: '#4D4D4D',
    imageScale: 'fullWidth',
    iconAlignment: 'center',
    iconCardAlignment: 'Right',
    iconCardBackgroundColor: '#FFFFFF',
    iconCardBorderSize: 0,
    iconCardBorderColor: '#FFFFFF',
    iconCardBorderRadius: 0,
    dataLanguage: 'Fa',
  };

  specificButtonChartProperties = {
    borderColor: '#eaeaea',
    guideAlign: 'center',
    labelColor: '#4D4D4D',
    labelFontSize: 24,
    scale: 'بدون مقیاس',
    field: true,
    fieldNameFontFamily: 'iranyekan',
    fieldNameFontSize: 18,
    fieldNameColor: '#4D4D4D',
    headerAlignmentOption: 'Right',
    textAlign: 'Center',
    toggleCustomText: false,
    customTextFontFamily: 'iranyekan',
    customTextFontSize: '11',
    customTextColor: '#FFFFFF',
    toggleIcon: false,
    iconType: null,
    iconSize: 42,
    iconColor: '#4D4D4D',
    svgIconSize: 42,
    svgIconColor: '#4D4D4D',
    imageScale: 'fullWidth',
    iconAlignment: 'center',
    iconCardAlignment: 'Right',
    iconCardBackgroundColor: '#FFFFFF',
    iconCardBorderSize: 0,
    iconCardBorderColor: '#FFFFFF',
    iconCardBorderRadius: 0,
    titleToggle: false,
    customText: 'اعمال کنترلگرها',
    btnBackgroundColor: '#009FE3',
    btnBorderColor: '#EDEDED'
  };

  specificTableChartProperties = {
    scale: 'بدون مقیاس',
    field: false,
    fieldNameFontFamily: 'iranyekan',
    fieldNameFontSize: 14,
    fieldNameColor: '#212529',
    showNumberColumn: false,
    verticalGrid: true,
    verticalGridColor: '#EDEDED',
    verticalGridWidth: 1,
    verticalRowPadding: 32,
    horizontalGrid: true,
    horizontalGridColor: '#EDEDED',
    horizontalGridWidth: 1,
    headerFontFamily: 'iranyekan',
    headerFontSize: 14,
    headerFontColor: '#4D4D4D',
    headerBackgroundColor: '#F8F8F8',
    headerOutlineColor: '#EDEDED',
    headerOutlineWidth: 1,
    headerOption: 'Top + Bottom only',
    autoSizeHeader: true,
    headerAlignmentOption: 'Right',
    headerWordWrap: false,
    fontOnEachColumns: false,
    fontOptionsOnEachColumns: {},
    hasUnitOnEachColumn: false,
    unitOptionsOnEachColumn: {},
    isColorOnEachColumns: false,
    colorOnEachColumns: {},
    valuesFontFamily: 'iranyekan',
    valuesFontSize: 12,
    valuesFontColor: '#4D4D4D',
    valuesAlignmentOption: 'center',
    valuesBackgroundColor: '#FFFFFF',
    valuesAlternateFontColor: 'rgba(0,0,0,0.7)',
    valuesAlternateBackgroundColor: '#FFFFFF',
    valuesOutlineColor: 'rgba(0,0,0,0.1)',
    valuesOutlineOption: 'Top + Bottom only',
    valuesWordWrap: false,
    totals: false,
    totalsLabel: 'کل',
    totalsFontFamily: 'iranyekan',
    totalsFontSize: 14,
    totalsFontColor: '#4D4D4D',
    paginationIconsColor: '#4D4D4D',
    linesInPage: 10,
    totalsBackgroundColor: '#F8F8F8',
    totalsOutlineColor: 'rgba(0,0,0,0.1)',
    totalsOutlineOption: 'Top + Bottom only',
    conditionalFormatting: false,
    conditionalFormattingApplyTo: 'Values only',
    conditionalFields: {},
    fitOption: 'right',
  };

  specificMatrixChartProperties = {
    scale: 'بدون مقیاس',
    field: false,
    fieldNameFontFamily: 'iranyekan',
    fieldNameFontSize: 14,
    fieldNameColor: '#212529',
    showNumberColumn: false,
    verticalGrid: true,
    verticalGridColor: '#EDEDED',
    collapsibleIconColor: '#4d4d4d',
    collapsibleIconWidth: 16,
    verticalGridWidth: 1,
    verticalRowPadding: 32,
    horizontalGrid: true,
    horizontalGridColor: '#EDEDED',
    horizontalGridWidth: 1,
    headerFontFamily: 'iranyekan',
    headerFontSize: 14,
    headerFontColor: '#4D4D4D',
    headerBackgroundColor: '#F8F8F8',
    headerOutlineColor: '#EDEDED',
    headerOutlineWidth: 1,
    headerOption: 'Top + Bottom only',
    autoSizeHeader: true,
    headerAlignmentOption: 'Center',
    columnHeaderAlignmentOption: 'Center',
    headerWordWrap: false,
    rowHeaderFontFamily: 'iranyekan',
    rowHeaderFontSize: 14,
    rowHeaderFontColor: '#4D4D4D',
    rowHeaderBackgroundColor: '#F8F8F8',
    rowHeaderOutlineColor: '#EDEDED',
    rowHeaderOutlineWidth: 1,
    rowHeaderOption: 'Top + Bottom only',
    rowHeaderAlignmentOption: 'Center',
    rowHeaderWordWrap: false,
    fontOnEachColumns: false,
    customOptionsOnEachValueColumns: {},
    isColorOnEachColumns: false,
    colorOnEachColumns: {},
    valuesFontFamily: 'iranyekan',
    valuesFontSize: 12,
    valuesFontColor: '#4D4D4D',
    valuesAlignmentOption: 'Center',
    valuesBackgroundColor: '#FFFFFF',
    valuesAlternateFontColor: 'rgba(0,0,0,0.7)',
    valuesAlternateBackgroundColor: '#FFFFFF',
    valuesOutlineColor: 'rgba(0,0,0,0.1)',
    valuesOutlineOption: 'Top + Bottom only',
    valuesWordWrap: false,
    totals: false,
    totalsLabel: 'مجموع',
    totalsFontFamily: 'iranyekan',
    totalsFontSize: 14,
    totalsFontColor: '#4D4D4D',
    paginationIconsColor: '#4D4D4D',
    linesInPage: 10,
    totalsBackgroundColor: '#F8F8F8',
    totalsOutlineColor: 'rgba(0,0,0,0.1)',
    totalsOutlineOption: 'Top + Bottom only',
    conditionalFormatting: false,
    conditionalFormattingApplyTo: 'Values only',
    conditionalFields: {},
    fitOption: 'right',
    columnGeneralTotal: true,
    columnSubTotal: true,
    rowGeneralTotal: true,
    rowSubTotal: true,
    columnGeneralTotalFontSize: 14,
    columnGeneralTotalFontColor: '#4D4D4D',
    columnGeneralTotalBackgroundColor: 'rgba(0,0,0,0.1)',
    columnGeneralTotalAlignmentOption: 'Center',
    columnGeneralTotalLabel: 'ColumnTotal',
    columnSubTotalLabel: 'ColumnSubTotal',
    rowGeneralTotalLabel: 'RowTotal',
    rowSubTotalLabel: 'RowSubTotal',
  };

  specificPieChartProperties = {
    groupLabelUnit: 0,
    transparentDisplay: false,
    headerAlignmentOption: 'Right',
    dataLanguage: 'Fa',
    toggleLegendLimitChars: true,
    legendMaxChars: 10,
    toggleLabelMoreSetting: false,
    labels: {
      columns: {},
    },
  };

  specificRadarChartProperties = {
    legendMaxChars: 10,
    transparentDisplay: false,
    headerAlignmentOption: 'Right',
    dataLanguage: 'Fa',
    borderColor: '#EAEAEA',
    toggleLegendLimitChars: true,
    columnsLineStyleOptions: {
      styleOnEachColumn: false,
      allLineType: 'line',
      allLineWidth: 2,
      columns: {},
    },
    columnsPointStyleOptions: {
      pointOnEachColumn: false,
      allPointStyle: 'circle',
      allPointRadius: 1,
      columns: {},
    },
  };

  specificTextBoxChartProperties = {
    titleToggle: false,
    textFontFamily: 'iranyekan',
    textFontSize: 14,
    textColor: '#4D4D4D',
    textLineHeight: 14,
    textDirection: 'RTL',
    textIsBold: false,
    textIsUnderlined: false,
    textAlign: 'Right',
    text:'',
  };

  specificIframeChartProperties = {
    titleToggle: true,
    textFontFamily: 'iranyekan',
    textFontSize: 14,
    textColor: '#4D4D4D',
    textLineHeight: 14,
    textDirection: 'RTL',
    textIsBold: false,
    textIsUnderlined: false,
    textAlign: 'Right',
    text:'',
  };

  specificImageChartProperties = {
    textFontFamily: 'iranyekan',
    textFontSize: 14,
    textColor: '#4D4D4D',
    textLineHeight: 11,
    textDirection: 'RTL',
    textIsBold: false,
    textIsUnderlined: false,
    titleTextAlign: 'Right',
    text:'',
    imageBorderRadius: 0,
    imageBorderSize: 0,
    imageBorderColor: '#FFFFFF',
    imageRotation: 0,
    imageAlignment: 'center',
    imageScale: 'fullWidth',
    linkActivated: false,
    linkType: 'URL',
    linkUrl: null,
  };

  specificScatterChartProperties = {
    scaleName: 'گسسته',
    transparentDisplay: true,
    headerAlignmentOption: 'Right',
    dataLanguage: 'Fa',
    defaultShape: 'circle',
    toggleShapeOnEachColumn: false,
    columnsShapes: {},
    toggleLabelMoreSetting: false,
    labels: {
      columns: {},
    },
    toggleLegendLimitChars: true,
    legendMaxChars: 10,
    zoomToggle: true,
  };

  specificShapeMapChartProperties = {
    arcColor: '#4D4D4D',
    arcSize: 1,
    undefinedColor: '#E8E8E8',
    seaColor: '#29b6f6',
    colorGuide: true,
    zoom: true,
    dataFormat: 'Fa',
    detailsCharLimitApply: true,
    detailsCharLimit: 10,
    titleTextAlign: 'Right',
    mapLabelType: 'مقدار',
    mapLabelKey: '',
  };

  specificTreeMapChartProperties = {
    toggleLegendLimitChars: true,
    headerAlignmentOption: 'Right',
    dataLanguage: 'Fa',
    legendMaxChars: 10,
    groupLabelUnit: 0,
  };

  specificGaugeChartProperties = {
    customMinValue: null,
    customMaxValue: null,
    customTargetValue: null,
    toggleIndicatorConditionalFormatting: false,
    eligibleIndicatorColor: '#1AAB40',
    ineligibleIndicatorColor: '#D64554',
  };

  specificAdvancedGaugeChartProperties = {
    customMinValue: null,
    customMaxValue: null,
    customTargetValue: null,
    domainColoringValue:[],
    toggleIndicatorConditionalFormatting: false,
    eligibleIndicatorColor: '#1AAB40',
    ineligibleIndicatorColor: '#D64554',
    titleToggle: true,
    fontFamily: 'iranyekan',
    fontSize: 14,
    fontColor: '#4D4D4D',
    titleDirection: 'RTL',
    textIsBold: false,
    textIsUnderlined: false,
    titleAlign: 'Right',
    deviderColor: '#E8E8E8',
    headerAlignmentOption: 'Right',
  };

  specificSankeyChartProperties = {
    headerAlignmentOption: 'Right',
    labelToggle: false,
    labelFontSize: 10,
    nodeLabelToggle: true,
    nodeLabelFontSize: 10,
    nodeLabelFontFamily: 'iranyekan',
    nodeLabelColor: '#4D4D4D',
    linkColor: 'static',
    nodesAlignment: 'justify',
  };

  specificKPIChartProperties = {
    labelUnit: 'ﺑﺪون واﺣﺪ',
    favorableColor: '#1AAB40',
    unfavorableColor: '#E52438',
    indicatorDirection: 'صعودی مطلوب',
  };

  specificCollapsableNetworkChartProperties = {
    transparentDisplay: false,
    headerAlignmentOption: 'Right',
    zoomToggle: true,
    iconColor: '#00000066',
  };

  specificWaterFallChartProperties = {
    transparentDisplay: false,
    increasesColor: '#1AAB40',
    decreasesColor: '#D64554',
    totalColor: '#008ECB',
    toggleLegendLimitChars: true,
    legendMaxChars: 10,
    annotationsLineEnabled: true,
    annotationsLineColor: '#000000',
  };

  specificGeoMapChartProperties = {
    arcSize: 1,
    arcColor: '#4D4D4D',
    undefinedColor: '#E8E8E8',
    headerAlignmentOption: 'Right',
    dataLanguage: 'Fa',
    toggleLabelMoreSetting: false,
    labels: {
      columns: {},
    },
    toggleLegendLimitChars: true,
    legendMaxChars: 10,
    mapMode: 'Online',
    mapLabelType: 'مقدار',
    mapLabelKey: '',
  };

  specificBubbleMapChartProperties = {
    arcSize: 1,
    arcColor: '#4D4D4D',
    undefinedColor: '#E8E8E8',
    headerAlignmentOption: 'Right',
    dataLanguage: 'Fa',
    toggleLabelMoreSetting: false,
    labels: {
      columns: {},
    },
    guideToggle: true,
    toggleLegendLimitChars: true,
    legendMaxChars: 10,
    mapMode: 'Online',
    mapLabelType: 'مقدار',
    mapLabelKey: '',
  };

  specificKPIChartSectionsProperties = {
    indicator: {
      fontFamily: 'iranyekan',
      fontSize: 64,
    },
    target: {
      toggle: true,
      label: 'هدف',
      language: 'Fa',
      fontFamily: 'iranyekan',
      fontSize: 20,
      labelColor: '#4D4D4D',
    },
    distance: {
      toggle: false,
      label: 'درصد',
      fontFamily: 'iranyekan',
      fontSize: 20,
      labelColor: '#4D4D4D',
      distanceDirection: 'صعودی مثبت',
    },
    processChart: {
      lineWidth: 1,
      lineTension: 0,
      toggle: true,
    },
    process: {
      toggle: false,
      fontFamily: 'iranyekan',
      fontSize: 16,
      labelColor: '#4D4D4D',
    },
     iconToggle: false,
     iconSize: 39,
  };

  specificGaugeChartSectionsProperties = {
    targetValueColor: '#4C5D8A',
    achievementUnit: 'بدون واحد',
    achievementDecimalPoints: 1,
    achievementFontFamily: 'iranyekan',
    achievementFontSize: 18,
    achievementColor: '#4D4D4D',
    achievementField: true,
    achievementFieldTitle: '',
    achievementFieldFontFamily: 'iranyekan',
    achievementFieldFontSize: 12,
    achievementFieldColor: '#4D4D4D',
    achievementFieldAlign: 'Center',
    achievementLabelToggle: false,
    achievementLabelFontSize: 11,
    achievementLabelFontFamily: 'iranyekan',
    achievementLabelColor: '#4D4D4D',
    achievementLabelBackgroundColor: 'rgba(0,0,0,0)',
    achievementLabelPlace: 'بالا',
    achievementLabelRotation: 'افقی',
    achievementLabelUnit: 'بدون مقیاس',
    intervalColor: '#EAEAEA',
    needleValueColor: '#454545',
    outerLabelToggle: false,
    outerLabelFontSize: 11,
    outerLabelFontFamily: 'iranyekan',
    outerLabelColor: '#4D4D4D',
    outerLabelBackgroundColor: 'rgba(0,0,0,0)',
    outerLabelPlace: 'بالا',
    outerLabelRotation: 'افقی',
    outerLabelUnit: 'بدون مقیاس',
  };
  specificAdvancedGaugeChartSectionsProperties = {
    targetValueColor: '#4C5D8A',
    achievementUnit: 'بدون مقیاس',
    achievementDecimalPoints: 1,
    achievementFontFamily: 'iranyekan',
    achievementFontSize: 18,
    achievementColor: '#4D4D4D',
    achievementField: true,
    achievementFieldTitle: '',
    achievementFieldFontFamily: 'iranyekan',
    achievementFieldFontSize: 12,
    achievementFieldColor: '#4D4D4D',
    achievementFieldAlign: 'Center',
    achievementLabelToggle: false,
    achievementLabelFontSize: 11,
    achievementLabelFontFamily: 'iranyekan',
    achievementLabelColor: '#4D4D4D',
    achievementLabelBackgroundColor: 'rgba(0,0,0,0)',
    achievementLabelPlace: 'بالا',
    achievementLabelRotation: 'افقی',
    achievementLabelUnit: 'بدون مقیاس',
    intervalColor: '#EAEAEA',
    needleValueColor: '#454545',
    outerLabelToggle: false,
    outerLabelFontSize: 11,
    outerLabelFontFamily: 'iranyekan',
    outerLabelColor: '#4D4D4D',
    outerLabelBackgroundColor: 'rgba(0,0,0,0)',
    outerLabelPlace: 'بالا',
    outerLabelRotation: 'افقی',
    outerLabelUnit: 'بدون مقیاس',
    innerLabelToggle: false,
    innerLabelFontSize: 11,
    innerLabelFontFamily: 'iranyekan',
    innerLabelColor: '#4D4D4D',
  };

  specificCollapsableNetworkSectionsProperties = {
    showLinkWeightLabel: false,
    linkWeightLabelFontFamily: 'iranyekan',
    linkWeightLabelFontSize: 10,
    linkWeightLabelColor: '#666666',
    linkWeightLabelUnit: 'بدون مقیاس',
    showSourceNodeLabel: false,
    sourceNodeLabelFontFamily: 'iranyekan',
    sourceNodeLabelFontSize: 10,
    sourceNodeLabelColor: '#666666',
    showSourceGroupLabel: false,
    sourceGroupLabelFontFamily: 'iranyekan',
    sourceGroupLabelFontSize: 10,
    sourceGroupLabelColor: '#666666',
    showDestinationNodeLabel: false,
    destinationNodeLabelFontFamily: 'iranyekan',
    destinationNodeLabelFontSize: 10,
    destinationNodeLabelColor: '#666666',
    showDestinationGroupLabel: false,
    destinationGroupLabelFontFamily: 'iranyekan',
    destinationGroupLabelFontSize: 10,
    destinationGroupLabelColor: '#666666',
    simulationStrength: -100,
    simulationMinDistance: 20,
    simulationMaxDistance: 300,
    simulationLinkDistance: 30,
    simulationLinkIteration: 1,
    moveNodesOnDragEnd: true,
  };

  specificTreeMapChartSectionsProperties = {
    showGroupLabels: true,
    groupLabelsFontFamily:'iranyekan',
    groupLabelsFontSize: 12,
    groupLabelsColor: '#000000',
  };

  specificGeoMapSectionsProperties = {
    zoomToggle: true,
    iconColor: '#00000066',
  };

  specificBubbleMapSectionsProperties = {
    zoomToggle: true,
    iconColor: '#00000066',
    bubbleSize: 15,
  };

  specificGaugeAxisesProperties = {
    x:{
      toggleLimitChars: true,
      maxChars: 10,
    },
  };

  specificAdvancedGaugeAxisesProperties = {
    x:{
      toggleLimitChars: true,
      maxChars: 10,
    },
  };

  specificShapeMapAxisesProperties = {
    x:{
      toggleLimitChars: true,
      maxChars: 10,
    },
  };

  specificRadarChartAxisesProperties = {
    r: {
      titrToggle: true,
      titrFontFamily: 'iranyekan',
      titrFontSize: 10,
      titrColor: '#4D4D4D',
      unitName: 'ﺑﺪون واﺣﺪ',
      guidelinesColor: 'rgba(0, 0, 0, 0.1)',
      guidelinesBorderWidth: 1,
      guideLinesBorderDash: 'line',
      scaleFontFamily: 'iranyekan',
      scaleFontSize: 10,
      scaleTextColor: '#4D4D4D',
    },
  };

  specificLineChartAxisesProperties = {
    y2: {
      titrToggle: false,
      titrText: '',
      titrFontFamily: 'iranyekan',
      titrFontSize: 9,
      titrColor: '#4D4D4D',
      scaleColor: '#0000001A',
      scaleFontFamily: 'iranyekan',
      scaleFontSize: 10,
      scaleTextColor: '#4D4D4D',
      place: 'راست',
      lineToggle: true,
      scaleName: 'خطی',
      angleMin: null,
      angleMax: null,
      toggleGuidelines: false,
      guidelinesColor: 'rgba(0, 0, 0, 0.1)',
      offset: false,
      unit: 'None',
    },
  };


  specificClusteredColumnLineChartAxisProperties = {
    y: {
      titrToggle: false,
      titrText: '',
      titrFontFamily: 'iranyekan',
      titrFontSize: 9,
      titrColor: '#4D4D4D',
      scaleColor: '#0000001A',
      scaleFontFamily: 'iranyekan',
      scaleFontSize: 10,
      scaleTextColor: '#666',
      place: 'پایین',
      lineToggle: true,
      scaleName: 'خطی',
      angleMin: null,
      angleMax: null,
      toggleGuidelines: true,
      guidelinesColor: 'rgba(0, 0, 0, 0.1)',
      totalBarEnabled: true,
      totalBarPosition: 'end',
      offset: false,
      unit: 'None',
    },

  };

  constructor(private chartDesignSettingsVersionManager: ChartDesignVersionManagerService) { }

  public createChart(type: ChartType, dashboardId: string, workspaceId: string): Partial<ChartModel>{
    const chart = this.initializeChartGeneralProperties(type, dashboardId, workspaceId);
    chart.chartDesignSettings = this.initializeChartDesignSettings(type);
    return chart;
  }

  public createController(type: ChartType, dashboardId: string, workspaceId: string): Partial<ChartModel>{
    const controller = this.initializeChartGeneralProperties(type, dashboardId, workspaceId);
    controller.interactionWithPagesProperties = undefined;
    controller.chartDesignSettings = this.initializeControllerDesignSettings(type);
    return controller;
  }

  public resetFactoryChartDesignSettings(chart: Partial<ChartModel>): Partial<ChartModel> {
    chart.chartDesignSettings = this.initializeChartDesignSettings(chart.chartType);
    return chart;
  }

  public resetFactoryControllerDesignSettings(chart: Partial<ChartModel>): Partial<ChartModel> {
    chart.chartDesignSettings = this.initializeControllerDesignSettings(chart.chartType);
    return chart;
  }

  public convertChartDesignSettings(sourceChartType: ChartType,
                                     targetChartType: ChartType,
                                     sourceChartDesignSettings: Partial<ChartDesignSettings>): Partial<ChartDesignSettings> {
    if(this.chartsAreSameForConvert(sourceChartType, targetChartType)){
      return sourceChartDesignSettings;
    }
    let updatedDesignSettings = this.deleteSpecificChartDesignSettings(sourceChartType, sourceChartDesignSettings);
    updatedDesignSettings = this.addSpecificChartDesignSettings(targetChartType, updatedDesignSettings);
    return updatedDesignSettings;
  }

  private initializeChartGeneralProperties(type: ChartType, dashboardId: string,
                                           workspaceId: string): Partial<ChartModel> {

    return {
      dashboardId,
      chartType: type,
      workspaceId,
      assetType: 'Chart',
      inactive: false,
      isInteractableWithCharts: true,
      otherChartsInteractionStatusWithThis: [],
      interactionWithPagesProperties: {
        isInteractableWithPages: false,
        interactionWithPagesType: 'None',
        interactionWithPagesFilterTypes: ['WithoutFilter'],
        destinationDashboardId: null,
        destinationWorkspaceId: null,
        destinationURL: null,
      },
    };
  }

  private initializeChartDesignSettings(type: ChartType): Partial<ChartDesignSettings> {
    if (type === 'BarChart' || type === 'StackedBarChart' || type === 'Stacked100BarChart' ||
      type === 'BarChartHorizontal' || type === 'Stacked100BarChartHorizontal' ||
      type === 'StackedBarChartHorizontal') {
      return this.initializeBarChartDesignSettings();
    }else if(type === 'LineChart'){
      return this.initializeLineChartDesignSettings();
    }else if(type === 'AreaChart'){
      return this.initializeAreaChartDesignSettings();
    }else if(type === 'LineStackChart'){
      return this.initializeStackedAreaChartDesignSettings();
    }else if(type === 'StackedColumnLineChart' || type === 'ClusteredColumnLineChart'){
      return this.initializeColumnLineChartDesignSettings();
    }else if(type === 'CardChart'){
      return this.initializeCardChartDesignSettings();
    }
    else if(type === 'AdvancedCardChart'){
      return this.initializeAdvancedCardChartDesignSettings();
    }else if(type === 'ButtonChart'){
      return this.initializeButtonChartDesignSettings();
    }else if(type === 'TableChart'){
      return this.initializeTableChartDesignSettings();
    }else if(type === 'Matrix'){
      return  this.initializeMatrixChartDesignSettings();
    }else if(type === 'PieChart'){
      return this.initializePieChartDesignSettings();
    }else if(type === 'DoughnutChart'){
      return this.initializeDoughnutChartDesignSettings();
    }else if(type === 'RadarChart'){
      return this.initializeRadarChartDesignSettings();
    }else if(type === 'TextChart'){
      return this.initializeTextBoxChartDesignSettings();
    }else if(type === 'IframeChart'){
      return this.initializeIframeChartDesignSettings();
    }else if(type === 'ImageChart'){
      return this.initializeImageChartDesignSettings();
    }else if(type === 'ScatterChart'){
      return this.initializeScatterChartDesignSettings();
    }else if(type === 'ShapeMap'){
      return this.initializeShapeMapChartDesignSettings();
    }else if(type === 'TreeMap'){
      return this.initializeTreeMapChartDesignSettings();
    }else if(type === 'GaugeChart'){
      return this.initializeGaugeChartDesignSettings();
    }else if(type === 'AdvancedGaugeChart'){
      return this.initializeAdvancedGaugeChartDesignSettings();
    }else if(type === 'SankeyChart'){
      return this.initializeSankeyChartDesignSettings();
    }else if(type === 'KPIChart'){
      return this.initializeKPIChartDesignSettings();
    }else if(type === 'CollapsableNetworkChart'){
      return this.initializeCollapsableNetworkChartDesignSettings();
    }else if(type === 'WaterFall') {
      return this.initializeWaterFallChartDesignSettings();
    }else if(type === 'GeoMapChart') {
      return this.initializeGeoMapChartDesignSettings();
    }else if(type === 'BubbleChart') {
      return this.initializeBubbleMapChartDesignSettings();
    }
    console.error(`${type} not implemented`);
    return undefined;
  }

  private initializeControllerDesignSettings(type: ChartType): Partial<ChartDesignSettings> {
    if (type === 'DropdownController') {
      return this.initializeDropdownControllerDesignSettings();
    }else if (type === 'AdvancedFilterController') {
      return this.initializeAdvancedControllerDesignSettings();
    }else if (type === 'SliderController') {
      return this.initializeSlicerControllerDesignSettings();
    }else if (type === 'DateRangeController') {
      return this.initializeDateRangeControllerDesignSettings();
    } else if (type === 'DateListController') {
      return this.initializeDateListControllerDesignSettings();
    }
  }

  private initializeDateListControllerDesignSettings(): Partial<ChartDesignSettings> {
    const dateListControllerDesignSettings: Partial<ChartDesignSettings> =
      this.initializeGeneralControllerDesignSettings();
    const specificDateListControllerOptions = {
      calenderType: 'Shamsi',
      defaultValueDateList: [
        'Today', 'Yesterday', 'From7DaysAgo', 'From14DaysAgo', 'From28DaysAgo', 'From30DaysAgo', 'CurrentWeek',
        'CurrentWeekToToday', 'PreviousWeek', 'CurrentMonth', 'CurrentMonthToToday', 'PreviousMonth', 'CurrentSeason',
        'CurrentSeasonToDate', 'PreviousSeason', 'CurrentYear', 'CurrentYearToDate', 'PreviousYear',
      ],
      // fields for design and coloring settings
      dateListBorderColor:'#0000001a',
      dateListBackgroundColor: 'transparent',
      dateListTextColor: '#00000099',
      dateListSelectedFilterColor:'#999',
      dateListSelectedFilterIconColor:'',
      dateListValueBackgroundColor: '#dddddd',
      dateListValueTextColor: '#000',
    };
    Object.assign(dateListControllerDesignSettings.chart,specificDateListControllerOptions);
    return  dateListControllerDesignSettings;
  }

  private initializeDateRangeControllerDesignSettings(): Partial<ChartDesignSettings> {
    const dateRangeControllerDesignSettings: Partial<ChartDesignSettings> =
      this.initializeGeneralControllerDesignSettings();
    const specificDateRangeControllerOptions = {
      searchable: true,
      singleSelect: false,
      headerAlignmentOption: 'Right',
      dateControllerType: 'Calendar',

      // fields for design and coloring settings
      dateRangeBorderColor:'#0000001a',
      dateRangeBackgroundColor: 'transparent',
      dateRangeTextColor: '#00000099',
      dateRangeSelectedFilterColor:'#999',
      dateRangeSelectedFilterIconColor:'',
      dateRangeTextColorFilterized:'',
    };
    Object.assign(dateRangeControllerDesignSettings.chart,specificDateRangeControllerOptions);
    return  dateRangeControllerDesignSettings;
  }

  private initializeSlicerControllerDesignSettings(): Partial<ChartDesignSettings> {
    const slicerControllerDesignSettings: Partial<ChartDesignSettings> =
      this.initializeGeneralControllerDesignSettings();
    const specificSlicerControllerOptions = {
      showLimitLabels: true,
      headerAlignmentOption: 'Right',
      sliderBaseColor: '#999999',
      sliderTextColor: '#55637d',
    };
    Object.assign(slicerControllerDesignSettings.chart,specificSlicerControllerOptions);
    return  slicerControllerDesignSettings;
  }

  private initializeAdvancedControllerDesignSettings(): Partial<ChartDesignSettings> {
    const advancedControllerDesignSettings: Partial<ChartDesignSettings> =
        this.initializeGeneralControllerDesignSettings();
    const specificAdvancedControllerOptions = {
      headerAlignmentOption: 'Right',
      // default fields for the design settings of this controller
      advancedFilterFieldBorderColor:'#0000001a',
      advancedFilterFieldBackgroundColor: 'transparent',
      advancedFilterFieldTextColor: '#00000099',
    };
    Object.assign(advancedControllerDesignSettings.chart,specificAdvancedControllerOptions);
    return advancedControllerDesignSettings;
  }

  private initializeDropdownControllerDesignSettings(): Partial<ChartDesignSettings> {
    const dropdownControllerDesignSettings: Partial<ChartDesignSettings> =
      this.initializeGeneralControllerDesignSettings();
    const specificDropdownControllerOptions = {
      customMinValue: null,
      customMaxValue: null,
      customTargetValue: null,
      searchable: true,
      singleSelect: false,
      headerAlignmentOption: 'Right',
      // fields for design and coloring settings
      nsBorderColor:'#0000001a',
      nsBackgroundColor: 'transparent',
      nsTextColor: '#00000099',
      valueBackgroundColor: '#dddddd',
      valueTextColor: '#000',
    };
    Object.assign(dropdownControllerDesignSettings.chart,specificDropdownControllerOptions);
    return  dropdownControllerDesignSettings;
  }

  private initializeSankeyChartDesignSettings(): Partial<ChartDesignSettings> {
    const sankeyChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    Object.assign(sankeyChartDesignSettings.chart, this.specificSankeyChartProperties);
    return sankeyChartDesignSettings;
  }

  private initializeKPIChartDesignSettings(): Partial<ChartDesignSettings> {
    const kpiChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    kpiChartDesignSettings.axises = undefined;
    Object.assign(kpiChartDesignSettings.chart, this.specificKPIChartProperties);
    Object.assign(kpiChartDesignSettings.sections,this.specificKPIChartSectionsProperties);
    return kpiChartDesignSettings;
  }

  private initializeGaugeChartDesignSettings(): Partial<ChartDesignSettings>{
    const gaugeChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    Object.assign(gaugeChartDesignSettings.chart, this.specificGaugeChartProperties);
    Object.assign(gaugeChartDesignSettings.sections, this.specificGaugeChartSectionsProperties);
    Object.assign(gaugeChartDesignSettings.axises, this.specificGaugeAxisesProperties);
    return gaugeChartDesignSettings;
  }

  private initializeAdvancedGaugeChartDesignSettings(): Partial<ChartDesignSettings>{
    const gaugeChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    Object.assign(gaugeChartDesignSettings.chart, this.specificAdvancedGaugeChartProperties);
    Object.assign(gaugeChartDesignSettings.sections, this.specificAdvancedGaugeChartSectionsProperties);
    Object.assign(gaugeChartDesignSettings.axises, this.specificAdvancedGaugeAxisesProperties);
    return gaugeChartDesignSettings;
  }

  private initializeTreeMapChartDesignSettings(): Partial<ChartDesignSettings>{
    const treeMapChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    treeMapChartDesignSettings.axises = undefined;
    Object.assign(treeMapChartDesignSettings.chart,this.specificTreeMapChartProperties);
    Object.assign(treeMapChartDesignSettings.sections,this.specificTreeMapChartSectionsProperties);
    return treeMapChartDesignSettings;
  }

  private initializeShapeMapChartDesignSettings(): Partial<ChartDesignSettings>{
    const shapeMapChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    Object.assign(shapeMapChartDesignSettings.chart,this.specificShapeMapChartProperties);
    Object.assign(shapeMapChartDesignSettings.axises, this.specificShapeMapAxisesProperties);
    return shapeMapChartDesignSettings;
  }

  private initializeScatterChartDesignSettings(): Partial<ChartDesignSettings>{
    const scatterChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    Object.assign(scatterChartDesignSettings.chart,this.specificScatterChartProperties);
    return scatterChartDesignSettings;
  }

  private initializeImageChartDesignSettings(): Partial<ChartDesignSettings>{
    const imageBoxChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    Object.assign(imageBoxChartDesignSettings.chart, this.specificImageChartProperties);
    return imageBoxChartDesignSettings;
  }

  private initializeTextBoxChartDesignSettings(): Partial<ChartDesignSettings>{
    const textBoxChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    Object.assign(textBoxChartDesignSettings.chart, this.specificTextBoxChartProperties);
    return textBoxChartDesignSettings;
  }

  private initializeIframeChartDesignSettings(): Partial<ChartDesignSettings>{
    const iframeChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    Object.assign(iframeChartDesignSettings.chart, this.specificIframeChartProperties);
    return iframeChartDesignSettings;
  }

  private initializeRadarChartDesignSettings(): Partial<ChartDesignSettings> {
    const radarChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    Object.assign(radarChartDesignSettings.chart, this.specificRadarChartProperties);
    Object.assign(radarChartDesignSettings.axises, this.specificRadarChartAxisesProperties);
    return radarChartDesignSettings;
  }

  private initializeDoughnutChartDesignSettings(): Partial<ChartDesignSettings> {
    return this.initializePieChartDesignSettings();
  }

  private initializePieChartDesignSettings(): Partial<ChartDesignSettings> {
    const pieChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    pieChartDesignSettings.axises = undefined;
    pieChartDesignSettings.series = undefined;
    pieChartDesignSettings.chart.labelPlace = undefined;
    Object.assign(pieChartDesignSettings.chart, this.specificPieChartProperties);
    return pieChartDesignSettings;
  }

  private initializeTableChartDesignSettings(): Partial<ChartDesignSettings> {
    const tableChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    tableChartDesignSettings.axises = undefined;
    Object.assign(tableChartDesignSettings.chart, this.specificTableChartProperties);
    return tableChartDesignSettings;
  }

  private initializeMatrixChartDesignSettings(): Partial<ChartDesignSettings> {
    const matrixChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    matrixChartDesignSettings.axises = undefined;
    Object.assign(matrixChartDesignSettings.chart, this.specificMatrixChartProperties);
    return matrixChartDesignSettings;
  }

  private initializeCardChartDesignSettings(): Partial<ChartDesignSettings> {
    const cardChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    cardChartDesignSettings.axises = undefined;
    Object.assign(cardChartDesignSettings.chart, this.specificCardChartProperties);
    return cardChartDesignSettings;
  }

  private initializeAdvancedCardChartDesignSettings(): Partial<ChartDesignSettings> {
    const advancedCardChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    advancedCardChartDesignSettings.axises = undefined;
    Object.assign(advancedCardChartDesignSettings.chart, this.specificAdvancedCardChartProperties);
    return advancedCardChartDesignSettings;
  }

  private initializeButtonChartDesignSettings(): Partial<ChartDesignSettings> {
    const buttonChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    buttonChartDesignSettings.axises = undefined;
    Object.assign(buttonChartDesignSettings.chart, this.specificButtonChartProperties);
    return buttonChartDesignSettings;
  }

  private initializeAreaChartDesignSettings(): Partial<ChartDesignSettings>{
    return this.initializeLineChartDesignSettings();
  }

  private initializeStackedAreaChartDesignSettings(): Partial<ChartDesignSettings>{
    return this.initializeLineChartDesignSettings();
  }

  private initializeColumnLineChartDesignSettings(): Partial<ChartDesignSettings> {
    const columnLineChartDesignSettings: Partial<ChartDesignSettings> = this.initializeLineChartDesignSettings();
    Object.assign(columnLineChartDesignSettings.chart, this.specificColumnLineChartProperties);
    return columnLineChartDesignSettings;
  }

  private initializeLineChartDesignSettings(): Partial<ChartDesignSettings> {
    const lineChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    lineChartDesignSettings.customSeries = [];
    Object.assign(lineChartDesignSettings.chart, this.specificLineChartProperties);
    Object.assign(lineChartDesignSettings.axises, this.specificLineChartAxisesProperties);
    return lineChartDesignSettings;
  }

  private initializeBarChartDesignSettings(): Partial<ChartDesignSettings> {
    const barChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    barChartDesignSettings.axises.x.overflowAmount = 1;
    barChartDesignSettings.axises.y.place = 'پایین';
    Object.assign(barChartDesignSettings.chart, this.specificBarChartProperties);
    return barChartDesignSettings;
  }

  private initializeCollapsableNetworkChartDesignSettings(): Partial<ChartDesignSettings> {
    const collapsableNetworkChartDesignSettings: Partial<ChartDesignSettings> =
      this.initializeGeneralChartDesignSettings();
    collapsableNetworkChartDesignSettings.axises = {};
    Object.assign(collapsableNetworkChartDesignSettings.chart, this.specificCollapsableNetworkChartProperties);
    Object.assign(collapsableNetworkChartDesignSettings.sections, this.specificCollapsableNetworkSectionsProperties);
    return collapsableNetworkChartDesignSettings;
  }

  private initializeWaterFallChartDesignSettings(): Partial<ChartDesignSettings> {
    const waterFallChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    Object.assign(waterFallChartDesignSettings.chart, this.specificWaterFallChartProperties);
    return waterFallChartDesignSettings;
  }

  private initializeGeoMapChartDesignSettings(): Partial<ChartDesignSettings> {
    const geoMapChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    geoMapChartDesignSettings.axises = undefined;
    Object.assign(geoMapChartDesignSettings.chart, this.specificGeoMapChartProperties);
    Object.assign(geoMapChartDesignSettings.sections, this.specificGeoMapSectionsProperties);
    return geoMapChartDesignSettings;
  }


  private initializeBubbleMapChartDesignSettings(): Partial<ChartDesignSettings> {
    const bubbleMapChartDesignSettings: Partial<ChartDesignSettings> = this.initializeGeneralChartDesignSettings();
    bubbleMapChartDesignSettings.axises = undefined;
    Object.assign(bubbleMapChartDesignSettings.chart, this.specificBubbleMapChartProperties);
    Object.assign(bubbleMapChartDesignSettings.sections, this.specificBubbleMapSectionsProperties);
    return bubbleMapChartDesignSettings;
  }

  private initializeGeneralControllerDesignSettings(): Partial<ChartDesignSettings>{
    return {
      chart: {
        borderColor: '#FFFFFF',
        borderWidth: 1,
        titleToggle: false,
        titleText: 'نام کنترلگر',
        titleFontFamily: 'iranyekan',
        titleFontSize: 14,
        titleColor: '#4D4D4D',
        dividerColor: '#E8E8E8',
        backgroundColor: '#FFFFFF',
        sliderStep: 1,
      },
    };
  }

  private initializeGeneralChartDesignSettings(): Partial<ChartDesignSettings> {
    return {
      backText: '',
      backTextToggle: false,
      backTextAlignment: 'Right',
      axises: {...this.initialAxisProperties},
      chart: {
        borderColor: '#FFFFFF',
        borderWidth: 1,
        titleToggle: true,
        titleText: 'نام نمودار',
        titleFontFamily: 'iranyekan',
        titleFontSize: 14,
        titleColor: '#4D4D4D',
        backTextIconColorFilter:'',
        backTextSettings: {
          fontFamily: 'iranyekan',
          fontSize: 14,
          color: '#4D4D4D',
          alignment: 'Right',
          insightMode: 'custom',
          insightTone: null,
          insightSize: null,
          aiGenerationClicked: false,
          aiIsGenerating: false,
        },

        backTextIconColor:'#e8e8e8',
        deviderColor: '#E8E8E8',
        backgroundColor: '#FFFFFF',
        guideToggle: true,
        guideFontFamily: 'iranyekan',
        guideFontSize: 10,
        guidePosition: 'bottom',
        guideAlign: 'center',
        guideColor: 'black',
        labelToggle: false,
        labelFontSize: 11,
        labelFontFamily: 'iranyekan',
        labelColor: '#1a1a1a',
        labelBackgroundColor: 'rgba(0,0,0,0)',
        labelPlace: 'بالا',
        labelRotation: 'افقی',
        labelUnit: 'بدون مقیاس',
        labelFilter: 'None',
        specificTooltipToggle: true,
        specificTooltipBackgroundColor: '#4D4D4D',
        specificTooltipLabelColor: '#CCCCCC',
        specificTooltipValueColor: '#FFFFFF',
        specificTooltipFontFamily: 'iranyekan',
        specificTooltipFontSize: '10',
        totalLabelToggle: false,
        totalLabelFontSize: 10,
        totalLabelFontFamily: 'iranyekan',
        totalLabelColor: '#1A1A1A',
        totalLabelBackgroundColor: '#EDEDED',
        totalLabelRotation: 'افقی',
        totalLabelUnit: 'بدون مقیاس',
        isFullScreenChartWidthDisabled: false,
        datasourceDateToggle: false
      },
      sections: {},
      version: this.chartDesignSettingsVersionManager.getCurrentVersionValue(),
    };
  }

  private chartsAreSameForConvert(sourceChartType: ChartType, targetChartType: ChartType): boolean{
    const sourceIsBar = (sourceChartType === 'BarChart' || sourceChartType === 'StackedBarChart' ||
      sourceChartType === 'Stacked100BarChart' ||
      sourceChartType === 'BarChartHorizontal' || sourceChartType === 'Stacked100BarChartHorizontal' ||
      sourceChartType === 'StackedBarChartHorizontal');
    const destinationIsBar = (targetChartType === 'BarChart' || targetChartType === 'StackedBarChart' ||
      targetChartType === 'Stacked100BarChart' ||
      targetChartType === 'BarChartHorizontal' || targetChartType === 'Stacked100BarChartHorizontal' ||
      targetChartType === 'StackedBarChartHorizontal');
    if(sourceIsBar && destinationIsBar){
      return true;
    }

    const sourceIsLine = sourceChartType === 'LineChart' || sourceChartType === 'AreaChart'
      || sourceChartType === 'LineStackChart';
    const targetIsLine = targetChartType === 'LineChart' || targetChartType === 'AreaChart'
      || targetChartType === 'LineStackChart';
    if(sourceIsLine && targetIsLine){
      return true;
    }

    const sourceIsColumnLine = sourceChartType === 'StackedColumnLineChart' ||
      sourceChartType === 'ClusteredColumnLineChart';
    const targetIsColumnLine = targetChartType === 'StackedColumnLineChart' ||
      targetChartType === 'ClusteredColumnLineChart';
    if(sourceIsColumnLine && targetIsColumnLine){
      return true;
    }

    const sourceIsPie = sourceChartType === 'PieChart' || sourceChartType === 'DoughnutChart';
    const targetIsPie = targetChartType === 'PieChart' || targetChartType === 'DoughnutChart';
    if(sourceIsPie && targetIsPie){
      return true;
    }

    return false;
  }

  private deleteSpecificChartDesignSettings(chartType: ChartType, designSettings: Partial<ChartDesignSettings>):
    Partial<ChartDesignSettings> {
    const specificDesignKeys = this.getSpecificChartDesignKeysBasedOnChartType(chartType);
    specificDesignKeys.chartKeys.forEach(key => {
      delete designSettings.chart[key];
    });
    specificDesignKeys.sectionKeys.forEach(key => {
      delete designSettings.sections[key];
    });
    specificDesignKeys.axisesKeys.forEach(key => {
      delete designSettings.axises[key];
    });
    return designSettings;
  }

  private addSpecificChartDesignSettings(chartType: ChartType, designSettings: Partial<ChartDesignSettings>):
    Partial<ChartDesignSettings> {
    if(!designSettings.axises || !designSettings.axises?.x || !designSettings.axises?.y){
      designSettings.axises = this.initialAxisProperties;
    }
    if(chartType === 'BarChart' || chartType === 'StackedBarChart' || chartType === 'Stacked100BarChart' ||
      chartType === 'BarChartHorizontal' || chartType === 'Stacked100BarChartHorizontal' ||
      chartType === 'StackedBarChartHorizontal'){
      Object.assign(designSettings.chart, this.specificBarChartProperties);
    }else if(chartType === 'LineChart'|| chartType === 'AreaChart' || chartType === 'LineStackChart'){
      Object.assign(designSettings.chart, this.specificLineChartProperties);
      Object.assign(designSettings.axises, this.specificLineChartAxisesProperties);
      designSettings.customSeries = [];
    }else if(chartType === 'StackedColumnLineChart' || chartType === 'ClusteredColumnLineChart'){
      Object.assign(designSettings.chart, this.specificLineChartProperties);
      Object.assign(designSettings.axises, this.specificLineChartAxisesProperties);
      designSettings.customSeries = [];
      Object.assign(designSettings.chart, this.specificColumnLineChartProperties);
    }else if(chartType === 'CardChart'){
      Object.assign(designSettings.chart, this.specificCardChartProperties);
    }else if(chartType === 'AdvancedCardChart'){
      Object.assign(designSettings.chart, this.specificAdvancedCardChartProperties);
    }
    else if(chartType === 'ButtonChart'){
      Object.assign(designSettings.chart, this.specificButtonChartProperties);
    }else if(chartType === 'TableChart'){
      Object.assign(designSettings.chart, this.specificTableChartProperties);
    }else if(chartType === 'PieChart' || chartType === 'DoughnutChart'){
      Object.assign(designSettings.chart, this.specificPieChartProperties);
    }else if(chartType === 'RadarChart'){
      Object.assign(designSettings.chart, this.specificRadarChartProperties);
      Object.assign(designSettings.axises, this.specificRadarChartAxisesProperties);
    }else if(chartType === 'TextChart'){
      Object.assign(designSettings.chart, this.specificTextBoxChartProperties);
    }else if(chartType === 'IframeChart'){
      Object.assign(designSettings.chart, this.specificIframeChartProperties);
    }else if(chartType === 'ImageChart'){
      Object.assign(designSettings.chart, this.specificImageChartProperties);
    }else if(chartType === 'ScatterChart'){
      Object.assign(designSettings.chart, this.specificScatterChartProperties);
    }else if(chartType === 'ShapeMap'){
      Object.assign(designSettings.chart, this.specificShapeMapChartProperties);
      Object.assign(designSettings.axises, this.specificShapeMapAxisesProperties);
    }else if(chartType === 'TreeMap'){
      Object.assign(designSettings.chart, this.specificTreeMapChartProperties);
      Object.assign(designSettings.sections, this.specificTreeMapChartSectionsProperties);
    }else if(chartType === 'GaugeChart'){
      Object.assign(designSettings.chart, this.specificGaugeChartProperties);
      Object.assign(designSettings.sections, this.specificGaugeChartSectionsProperties);
      Object.assign(designSettings.axises, this.specificGaugeAxisesProperties);
    }else if(chartType === 'AdvancedGaugeChart'){
      Object.assign(designSettings.chart, this.specificAdvancedGaugeChartProperties);
      Object.assign(designSettings.sections, this.specificAdvancedGaugeChartSectionsProperties);
      Object.assign(designSettings.axises, this.specificAdvancedGaugeAxisesProperties);
    }else if(chartType === 'SankeyChart'){
      Object.assign(designSettings.chart, this.specificSankeyChartProperties);
    }else if(chartType === 'KPIChart'){
      Object.assign(designSettings.chart, this.specificKPIChartProperties);
      Object.assign(designSettings.sections, this.specificKPIChartSectionsProperties);
    }else if(chartType === 'CollapsableNetworkChart'){
      Object.assign(designSettings.chart, this.specificCollapsableNetworkChartProperties);
      Object.assign(designSettings.sections, this.specificCollapsableNetworkSectionsProperties);
    }else if(chartType === 'WaterFall') {
      Object.assign(designSettings.chart, this.specificWaterFallChartProperties);
    }else if(chartType === 'GeoMapChart') {
      Object.assign(designSettings.chart, this.specificGeoMapChartProperties);
      Object.assign(designSettings.sections, this.specificGeoMapSectionsProperties);
    }else if(chartType === 'BubbleChart') {
      Object.assign(designSettings.chart, this.specificBubbleMapChartProperties);
      Object.assign(designSettings.sections, this.specificBubbleMapSectionsProperties);
    }
    return designSettings;
  }

  private getSpecificChartDesignKeysBasedOnChartType(chartType: ChartType): { chartKeys: string[];
    sectionKeys: string[]; axisesKeys: string[];} {
    if (chartType === 'BarChart' || chartType === 'StackedBarChart' || chartType === 'Stacked100BarChart' ||
      chartType === 'BarChartHorizontal' || chartType === 'Stacked100BarChartHorizontal' ||
      chartType === 'StackedBarChartHorizontal') {
      return {chartKeys:Object.keys(this.specificBarChartProperties), sectionKeys:[], axisesKeys: []};
    }else if(chartType === 'LineChart'|| chartType === 'AreaChart' || chartType === 'LineStackChart'){
      return {chartKeys:Object.keys(this.specificLineChartProperties), sectionKeys:[], axisesKeys: []};
    }else if(chartType === 'StackedColumnLineChart' || chartType === 'ClusteredColumnLineChart'){
      return {chartKeys:Object.keys(this.specificColumnLineChartProperties), sectionKeys:[], axisesKeys: []};
    }else if(chartType === 'CardChart'){
      return {chartKeys:Object.keys(this.specificCardChartProperties), sectionKeys:[], axisesKeys: []};
    }else if(chartType === 'AdvancedCardChart'){
      return {chartKeys:Object.keys(this.specificAdvancedCardChartProperties), sectionKeys:[], axisesKeys: []};
    }
    else if(chartType === 'ButtonChart'){
      return {chartKeys:Object.keys(this.specificButtonChartProperties), sectionKeys:[], axisesKeys: []};
    }else if(chartType === 'TableChart'){
      return {chartKeys:Object.keys(this.specificTableChartProperties), sectionKeys:[], axisesKeys: []};
    }else if(chartType === 'PieChart' || chartType === 'DoughnutChart'){
      return {chartKeys:Object.keys(this.specificPieChartProperties), sectionKeys:[], axisesKeys: []};
    }else if(chartType === 'RadarChart'){
      return {chartKeys:Object.keys(this.specificRadarChartProperties), sectionKeys:[],
        axisesKeys: Object.keys(this.specificRadarChartAxisesProperties)};
    }else if(chartType === 'TextChart'){
      return {chartKeys:Object.keys(this.specificTextBoxChartProperties), sectionKeys:[], axisesKeys: []};
    }else if(chartType === 'IframeChart'){
      return {chartKeys:Object.keys(this.specificIframeChartProperties), sectionKeys:[], axisesKeys: []};
    }else if(chartType === 'ImageChart'){
      return {chartKeys:Object.keys(this.specificImageChartProperties), sectionKeys:[], axisesKeys: []};
    }else if(chartType === 'ScatterChart'){
      return {chartKeys:Object.keys(this.specificScatterChartProperties), sectionKeys:[], axisesKeys: []};
    }else if(chartType === 'ShapeMap'){
      return {chartKeys:Object.keys(this.specificShapeMapChartProperties), sectionKeys:[],
        axisesKeys: Object.keys(this.specificShapeMapAxisesProperties)};
    }else if(chartType === 'TreeMap'){
      return {chartKeys:Object.keys(this.specificTreeMapChartProperties),
        sectionKeys: Object.keys(this.specificTreeMapChartSectionsProperties), axisesKeys: []};
    }else if(chartType === 'GaugeChart'){
      return {chartKeys:Object.keys(this.specificGaugeChartProperties),
        sectionKeys: Object.keys(this.specificGaugeChartSectionsProperties),
        axisesKeys: Object.keys(this.specificGaugeAxisesProperties)};
    }else if(chartType === 'AdvancedGaugeChart'){
      return {chartKeys:Object.keys(this.specificAdvancedGaugeChartProperties),
        sectionKeys: Object.keys(this.specificAdvancedGaugeChartSectionsProperties),
        axisesKeys: Object.keys(this.specificAdvancedGaugeAxisesProperties)};
    }else if(chartType === 'SankeyChart'){
      return {chartKeys:Object.keys(this.specificSankeyChartProperties), sectionKeys:[], axisesKeys: []};
    }else if(chartType === 'KPIChart'){
      return {chartKeys:Object.keys(this.specificKPIChartProperties),
        sectionKeys: Object.keys(this.specificKPIChartSectionsProperties), axisesKeys: []};
    }else if(chartType === 'CollapsableNetworkChart'){
      return {chartKeys:Object.keys(this.specificCollapsableNetworkChartProperties),
        sectionKeys:Object.keys(this.specificCollapsableNetworkSectionsProperties), axisesKeys: []};
    }else if(chartType === 'WaterFall') {
      return {chartKeys:Object.keys(this.specificWaterFallChartProperties), sectionKeys:[], axisesKeys: []};
    }
  }
}
